import React from "react";
import InternalLayout from "../components/InternalLayout";
import Content from "../components/Billing/get-all-bills-api";
import BillingComponent from "../components/Billing";
import withAuth from "../config/private-route";

const Billing = () => {
  return (
    <InternalLayout>
      <Content />
      <BillingComponent />
    </InternalLayout>
  );
};
export default withAuth(Billing);
